<template>
  <div class="wrapper__rules">
    <div
        :class="{
            'wrapper__rules__container animated': true,
            'bounceInDown': show,
            'bounceOutUp': !show
        }"
    >
        <a
            class="wrapper__rules__container__logo"
            :href="exits.lunchables"
            target="_blank"
            v-trackevent:val="'rules-logo'"
        >
            <img src="images/logo.png" alt="Lunchables"/>
        </a>

        <button
            class="wrapper__btn wrapper__rules__close"
            @click="close()"
            v-trackevent:val="'close-rules_btn'"
        ></button>

        <div class="wrapper__rules__legal">
            <perfect-scrollbar ref="scrollbar">
                <div class="wrapper__rules__scrollable">
                    <h2 class="wrapper__rules__title">
                        {{ type === 'rules' ? 'CONTEST OFFICIAL RULES' : 'PRIVACY POLICY'}}
                    </h2>
                    <p class="wrapper__rules__text" v-html="data"></p>
                </div>
            </perfect-scrollbar>
        </div>
    </div>
  </div>
</template>

<script>
    import CONFIG from '@/config';

    export default {

        name: 'Overlay',

        props: ['data', 'type'],

        data() {

            return {
                show: true,
                exits: {
                    lunchables: CONFIG.settings.exits.lunchables
                }
            };
        },

        methods: {

            close() {
                this.show = false;

                setTimeout(() => {
                    this.$emit('closeOverlay', true);
                }, 750);
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper__rules {
        align-items: center;
        background-color: rgba(252, 226, 58, .79);
        height: 100vh;
        left: 0;
        overflow: hidden;
        position: fixed;
        top: 0;
        width: 100vw;
        z-index: 11;

        &__close {
            background-image: url(/images/rules_close.png);
            height: 21px;
            position: absolute;
            top: 10px;
            right: 20px;
            width: 26px;
        }

        &__container {
            margin: 0px auto;
            text-align: center;
            max-width: 1000px;
            height: 100%;

            &__logo {
                display: block;
                margin: 6px auto 0px auto;
            }
        }

        &__legal {
            position: absolute;
            left: 50%;
            height: 400px;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1000px;

            @media screen and (min-height: 750px) {
                height: 650px;
            }

            .ps {
                height: 100%;
            }
        }

        &__title {
            color: #a4252a;
            font-family: 'Bungee', cursive;
            font-size: 34px;
            padding-bottom: 30px;
        }

        &__text {
            color: #a4252a;
            font-family: 'Open Sans', sans-serif;
            font-size: 16px;
        }
    }
</style>
